import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import QueryBuilderContent from '../components/query/QueryBuilderContent';

const QueryBuilder = () => {
  const [queryMode, setQueryMode] = useState('astroql');
  const [resultFormat, setResultFormat] = useState('csv');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();
  const initialQuery = location.state?.query || location.state?.prefilledQuery;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="p-1 rounded-md hover:bg-ui-light-hover dark:hover:bg-ui-dark-hover transition-colors"
          title={sidebarOpen ? "Hide database explorer" : "Show database explorer"}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-ui-light-text-tertiary dark:text-ui-dark-text-tertiary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <label htmlFor="queryModeSelect" className="text-sm text-ui-light-text-secondary dark:text-ui-dark-text-secondary">
              Mode:
            </label>
            <select
              id="queryModeSelect"
              value={queryMode}
              onChange={(e) => setQueryMode(e.target.value)}
              className="text-sm border border-ui-light-border dark:border-ui-dark-border rounded px-2 py-1 text-ui-light-text-primary dark:text-ui-dark-text-primary bg-ui-light-background dark:bg-ui-dark-hover focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 transition-colors"
            >
              <option value="astroql">astroql</option>
              <option value="adql">ADQL</option>
              <option value="sql">SQL</option>
            </select>
          </div>

          <div className="flex items-center space-x-2">
            <label htmlFor="resultFormatSelect" className="text-sm text-ui-light-text-secondary dark:text-ui-dark-text-secondary">
              Format:
            </label>
            <select
              id="resultFormatSelect"
              value={resultFormat}
              onChange={(e) => setResultFormat(e.target.value)}
              className="text-sm border border-ui-light-border dark:border-ui-dark-border rounded px-2 py-1 text-ui-light-text-primary dark:text-ui-dark-text-primary bg-ui-light-background dark:bg-ui-dark-hover focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 transition-colors"
            >
              <option value="csv">CSV</option>
              <option value="parquet">Parquet</option>
              <option value="fits">FITS</option>
            </select>
          </div>
        </div>
      </div>

      <QueryBuilderContent
        initialQuery={initialQuery}
        queryMode={queryMode}
        resultFormat={resultFormat}
        sidebarOpen={sidebarOpen}
        resultsId="query-results"
      />
    </div>
  );
};

export default QueryBuilder;
